import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-content">
        <p>
          2023 || Created by{" "}
          <a
            href="https://github.com/dxtaner"
            target="_blank"
            rel="noopener noreferrer">
            dxtaner
          </a>{" "}
          ❤️
        </p>
      </div>
    </div>
  );
}

export default Footer;
